import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppPreBootstrap } from 'AppPreBootstrap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApiService {

  constructor(private http: HttpClient) { }

  getHeaders(): HttpHeaders {
    const newToken = AppPreBootstrap.getTokenLocalstorage(AppConsts.authorization.newAccessToken);
    const oldUserId = abp.session.userId;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    if (newToken) {
      headers = headers.set('Authorization', `Bearer ${newToken}`);
    }

    if (oldUserId) {
      headers = headers.set('OldUserId', oldUserId.toString());
    }

    return headers;
  }

  /** unwrap ABP response: { result, success, error } */
  private unwrap<T>(res: any): T {
    if (res && typeof res === 'object' && 'success' in res) {
      if (res.success === false) {
        throw res;
      }
      return res.result as T;
    }
    return res as T;
  }

  request<T>(method: string, url: string, body?: any, params?: HttpParams | { [param: string]: string | string[] }): Observable<T> {
    return this.http.request(method, url, {
      body,
      params,
      headers: this.getHeaders(),
    }).pipe(map(res => this.unwrap<T>(res)));
  }

  getBlob(url: string, params?: HttpParams | { [param: string]: string | string[] }): Observable<Blob> {
    return this.http.get(url, {
      params,
      headers: this.getHeaders(),
      responseType: 'blob' // bắt buộc phải là blob
    });
  }

  upload<T>(url: string, formData: FormData, params?: HttpParams | { [param: string]: string | string[] }): Observable<T> {
    const headers = this.getHeaders().delete('Content-Type');

    return this.http.post(url, formData, {
      headers,
      params
    }).pipe(map(res => this.unwrap<T>(res)));
  }

  get<T>(url: string, params?: HttpParams | { [param: string]: string | string[] }) {
    return this.request<T>('GET', url, undefined, params);
  }

  post<T>(url: string, body: any, params?: HttpParams | { [param: string]: string | string[] }) {
    return this.request<T>('POST', url, body, params);
  }

  postBlob(url: string, body: any, params?: HttpParams | { [param: string]: string | string[] }): Observable<Blob> {
    return this.http.post<Blob>(url, body, {
      params,
      headers: this.getHeaders(), 
      responseType: 'blob' as 'json' // bắt buộc phải là blob
    });
  }

  put<T>(url: string, body: any, params?: HttpParams | { [param: string]: string | string[] }) {
    return this.request<T>('PUT', url, body, params);
  }

  delete<T>(url: string, params?: HttpParams | { [param: string]: string | string[] }) {
    return this.request<T>('DELETE', url, undefined, params);
  }
}
